import { Product } from '@core/models/piramide/Product';

export class Mother extends Product {
  $caracteristicas: {
    m2_sata: number;
    m2_nvme: number;
    _4pines?: number;
    _4plus: number;
    _24pines: number;
    Chipsets: string;
    DDR: number;
    DDR2: number;
    DDR3: number;
    DDR4: number;
    DP: number;
    Factor: string;
    Floppy: number;
    HDMI: number;
    IDE: number;
    PCI: number;
    PCIE1X: number;
    SATA: number;
    USB: number;
    activo: number;
    con_micro: number;
    cpus: string;
    dvi: number | string;
    id_producto: number;
    lan: string;
    m2: number;
    marca?: string | null;
    modelo?: string | null;
    nro_agp: number;
    nro_pcie: number;
    placa_audio: string;
    ps2: number;
    sistema_rgb: string;
    sodimm: number;
    tipo: string;
    tipo_multiplaca: string | number;
    usb20_trasero: number;
    usb30_trasero: number;
    usb31_trasero: number;
    vga: number;
    w: number;
    wifi_integrada: number;
    wmax: number;
    slot_memoria?: number;
    anclaje?: string;
    back_connect?: 1 | 0;
  };
  public constructor(product: Product) {
    super(product);
    if (product.id_subcategoria !== 49 && product.id_subcategoria !== 26) {
      throw 'esto no es un mother';
    }
  }
}
